import { Component } from "react"
import { Button, Result } from "antd"

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, message: "" }
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: error?.message || "An unexpected error occurred",
    }
  }

  componentDidCatch(error, info) {
    console.error("Application error boundary", error, info)
  }

  handleReset = () => {
    this.setState({ hasError: false, message: "" })
    if (this.props.onReset) {
      this.props.onReset()
    } else {
      window.location.assign("/")
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="sips">
          <Result
            status="error"
            title="This screen could not be loaded"
            subTitle={
              this.state.message
                ? `${this.state.message}. You can return to the dashboard and try again.`
                : "An unexpected error occurred. You can return to the dashboard and try again."
            }
            extra={
              <Button type="primary" onClick={this.handleReset}>
                Back to dashboard
              </Button>
            }
          />
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
